module.exports = __webpack_public_path__ + "af90cc999113eec03079027127627ea6.png";